import styled from 'styled-components'

export const Stamp = styled.div`
    background-image: url('/assets/img/stamps/extendedcardelivery.svg');
    background-repeat: no-repeat;
    background-size: 100%;
    width: ${props => props.isDA ? '120px' : '100px'};
    height: ${props => props.isDA ? '23px' : '25px'};
    margin-right: ${props => props.isDA && '15px'};
    margin-top: 2px;
`
